















































































import { Vue, Component } from 'vue-property-decorator'

@Component
export default class RegistrationProgress extends Vue {
    signupStepUrl =
        'https://usermodel-assets.s3-ap-northeast-1.amazonaws.com/musio-english-assets/step1_g.png'
    editStepUrl =
        'https://usermodel-assets.s3-ap-northeast-1.amazonaws.com/musio-english-assets/step2_g.png'
    completeStepUrl =
        'https://usermodel-assets.s3-ap-northeast-1.amazonaws.com/musio-english-assets/step3_g.png'
    arrowUrl =
        'https://usermodel-assets.s3-ap-northeast-1.amazonaws.com/musio-english-assets/Arrow.png'

    getPath(): string {
        return this.$router.currentRoute.path
    }
}
